<template>
	<div class="header">
		<div class="head_main">
			<el-image class="logo" src="./static/images/logo1.png" fit="contain">
				<div slot="error" class="image-slot">
					logo
				</div>
			</el-image>
		</div>
		<div class="headnav">
			<div class="nav">
				<div :class="active==item.url?'active':''" v-for="(item,index) in link" :key="index"
					@click="handlink(item.url)">{{item.name}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixins from '@/mixins/index'
	import localStorage from '@/utils/localStorage'
	export default {
		mixins: [mixins],
		data() {
			return {
				active: '',
				login: false,
				userInfo: [],
				link: [{
					url: '/',
					name: '首页',
				}, {
					url: '/about/about',
					name: '关于我们',
				}, {
					url: '/about/contact',
					name: '联系我们',
				}]
			}
		},
		// 检测路由变化
		watch: {
			$route() {
				this.setCurrentRoute();
			}
		},

		methods: {
			handlink(url) {
				this.active = url
				this.$router.push({
					path: url
				})
			},
			setCurrentRoute() {
				var path = this.$route.path
				this.active = path // 通过他就可以监听到当前路由状态并激活当前菜单
			},
		},
		created() {
			this.setCurrentRoute();
		}
	}
</script>

<style lang="scss" scoped>
	.header {
		background-color: #fff;
		height: 180px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;

		.head_main {
			max-width: 1200px;
			width: 100%;
			height: 120px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.logo {
				color: #666;
				font-size: 30px;
				font-weight: bold;
				width: 134px;
				height: 55px;
			}

		}

		.headnav {
			background-color: #2D82FF;
			height: 60px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
		}

		.nav {
			max-width: 1200px;
			width: 100%;
			height: 60px;
			display: flex;
			align-items: center;

			div {
				font-size: 18px;
				color: #000;
				width: 150px;
				height: 60px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				color: #fff;
			}

			.active {
				background: #FF6530;
				color: #fff;
			}

			div:hover {
				background: #FF6530;
				color: #fff;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/Header.vue